import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  mobileOtpVerifyServices,
  SendMobileOTPServices,
  SendMobileOTPServicesToUpdateMobile
} from "../../services";
import { timerCount } from "../../config";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";
import { toast } from "react-toastify";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const MobileUpdateOTPSend = ({
  setMobileverifyOtp,
  setMobileVerificationOTPSent1,
  setAdharOtp,
  setAdharNumber,
  setCurrentStep
}) => {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState("");
  const [msg, setMsg] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    const interval =
      timer > 0 && setInterval(() => setTimer((t) => t - 1), 1000);
    if (timer <= 0) setCanResend(true);
    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) {
      setMsg("Please enter a valid 10-digit mobile number.");
      return;
    }
    try {
      const body = {
        mobile,
        xToken: localStorage.getItem("downloadToken")
      };
      const response = await SendMobileOTPServicesToUpdateMobile({ body });
      if (response.success) {
        localStorage.setItem("newmobilenumber", mobile);
        localStorage.setItem("txnId", response.txnId);
        dispatch(setGlobalCurrentStep("MobileVerificationOTPVerifyToUpdateContact"));
      } else {
        toast.error(response?.message || response?.result?.error?.message);
      }
    } catch (err) {
      console.error("Mobile verification failed", err);
      toast.error(
        err?.message ||
          err?.result?.error?.message ||
          "Mobile verification failed"
      );
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA Address and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Mobile Input Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Verify Your Mobile Number</h3>
                  <p className="lmop-card-subtitle">
                    Enter your mobile number to receive an OTP
                  </p>

                  <form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      maxLength="10"
                      placeholder="Enter Mobile Number"
                      value={mobile}
                      autoComplete="off"
                      onChange={(e) => setMobile(e.target.value)}
                      className="lmop-mobile-input"
                    />
                    {msg && <p className="lmop-msg-err">{msg}</p>}

                    <button
                      type="submit"
                      className={`lmop-continue-btn ${mobile.length !== 10 ? "bg-disable" : ""}`}
                      disabled={mobile.length !== 10}
                    >
                      Verify
                    </button>
                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MobileUpdateOTPSend;